module.exports = __webpack_public_path__ + "img/arms-on-bg1.361620d6.png";